import { Yup, i18next } from '@lib/index';

const { t } = i18next;

const documentReviewFormValidation = Yup.object({
  isRejection: Yup.boolean(),
  revisionComment: Yup.string().when('isRejection', {
    is: true,
    then: (schema) => schema.required(t('alert.commentRequired')).ensure(),
    otherwise: (schema) => schema.nullable(),
  }),
});

export default documentReviewFormValidation;
